"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayPeriodDailyBreakdownView = void 0;
const utils_1 = require("../../../utils");
const react_i18next_1 = require("react-i18next");
const usePayPeriodDailyBreakdownView = ({ payPeriodDailyBreakdown, dateCell }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const data = Object.entries(payPeriodDailyBreakdown).map(([date, { scheduledMinutes, workedMinutes, anomaly }]) => ({
        date,
        dailyScheduledMin: (0, utils_1.getLocalizedDuration)({ minute: scheduledMinutes }, t) ||
            t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_NoSchedule'),
        dailyWorkedMin: (0, utils_1.getLocalizedDuration)({ minute: workedMinutes }, t) ||
            (scheduledMinutes ? '--' : null),
        anomalyFound: anomaly
    }));
    const columns = [
        {
            header: t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_Date'),
            cellComponent: dateCell,
            width: '24%'
        },
        {
            header: t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_Scheduled'),
            accessor: 'dailyScheduledMin',
            width: '30%'
        },
        {
            header: t('time_and_attendance_Timecard_PayPeriodDailyBreakDown_Actual'),
            accessor: 'dailyWorkedMin',
            width: '30%'
        }
    ];
    return {
        data,
        columns
    };
};
exports.usePayPeriodDailyBreakdownView = usePayPeriodDailyBreakdownView;
